import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    LayerMapTile: {
        meta: {
            i18nDescrKey: "info-gis-map",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD"
        },
        component: () => import("./components/tiles/LayerMapTile.vue")
    },
    LayerInfoTile: {
        meta: {
            i18nDescrKey: "info-gis",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD"
        },
        component: () => import("./components/tiles/LayerInfoTile.vue")
    },
    LayerLegendTile: () => import("./components/tiles/LayerLegendTile.vue"),
    LayerInfoContainer: () => import("./components/LayerInfoContainer.vue"),
    LayerManagerContainer: () => import("./components/LayerSingleTileContainer.vue"),
    LayerManager: () => import("./components/tiles/LayerManager.vue"),

    LayerCreateNewWMSLayer: () => import("./components/tiles/creation/LayerCreateNewWMSLayer.vue")
};

export default globals;
